import React from "react";
import { Routes, Route } from "react-router-dom";
import ChatbotPlans from "./ChatbotPlans";
import AssistantPlans from "./AssistantPlans";
import NativeClientPlatformPlans from "./NativeClientPlatformPlans";

export default function Plans() {
    return (
        <Routes>
          <Route index path={"/chatbot"} element={<ChatbotPlans/>}/>
          <Route path={"/assistant/*"} element={<AssistantPlans />} />
          <Route path={"/native-client-platform/*"} element={<NativeClientPlatformPlans />} />
        </Routes>
    );
}
